import { render, staticRenderFns } from "./addPricing.vue?vue&type=template&id=7dda4bcf&scoped=true"
import script from "./addPricing.vue?vue&type=script&lang=js"
export * from "./addPricing.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addPricing.vue?vue&type=style&index=1&id=7dda4bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dda4bcf",
  null
  
)

export default component.exports